(() => {
  const ROOT = '[data-kmk-mono-product]';
  const MOBILE = '(max-width: 749px)';

  const removeLegacyPreorder = (root) => {
    if (!(root instanceof Element) || !root.matches(ROOT)) return;

    root
      .querySelectorAll('[class*="stoq" i],[id*="stoq" i],[class*="preorder" i],[id*="preorder" i],[data-preorder]')
      .forEach((node) => node.remove());

    root.querySelectorAll('button,label,p,span').forEach((node) => {
      if (node.children.length > 0) return;
      if (!/(précommande|pre[- ]?order)/i.test(node.textContent || '')) return;

      const appBlock = node.closest('.shopify-app-block');
      const removalTarget = appBlock && root.contains(appBlock) ? appBlock : node;
      removalTarget.remove();
    });
  };

  const setup = (root) => {
    if (!(root instanceof Element) || root.dataset.kmkCampaignReady === 'true') return;
    root.dataset.kmkCampaignReady = 'true';

    const cta = root.querySelector('[data-kmk-mobile-cta]');
    const mainButton = root.querySelector('[data-kmk-primary-add]');
    const mobileButton = cta?.querySelector('button');
    const footer = document.querySelector('footer');
    const mobileQuery = window.matchMedia(MOBILE);
    let frame = 0;

    const setVisible = (visible) => {
      const show = Boolean(visible && mobileQuery.matches && mobileButton && !mobileButton.disabled);
      cta?.classList.toggle('is-visible', show);
      cta?.setAttribute('aria-hidden', show ? 'false' : 'true');
      cta?.toggleAttribute('inert', !show);
      if (mobileButton) mobileButton.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('kmk-mobile-cta-active', show);
    };

    const update = () => {
      frame = 0;
      if (!cta || !mainButton || !mobileQuery.matches) return setVisible(false);
      const buttonBounds = mainButton.getBoundingClientRect();
      const footerBounds = footer?.getBoundingClientRect();
      setVisible(buttonBounds.bottom < 0 && !(footerBounds && footerBounds.top < window.innerHeight));
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    mobileQuery.addEventListener?.('change', schedule);
    update();
  };

  const init = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches(ROOT)) roots.push(scope);
    scope.querySelectorAll?.(ROOT).forEach((root) => roots.push(root));

    roots.forEach((root) => {
      removeLegacyPreorder(root);
      setup(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
